import {
  EyeInvisibleOutlined,
  EyeOutlined,
  LockOutlined,
  UserOutlined
} from '@ant-design/icons'
import { Button, Checkbox, Form, Input, Row } from 'antd'
import { IconEmail } from 'common/SVG/svg.common'
import { getCookie, setCookie } from 'helper/cookie'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { TitlePrimary } from '../../App.styles'
import Axonslogo from '../../icons/header/axons.svg'
import lang from '../../lang/en'
import { handleLoginFailed, LoginLINK_Axons, loginUser } from '../../redux/user/user.action'
import '../../styleLess/signature/login.scss'
import { CardContainer, CardLogin } from './login.styles'
import {
  AnimationSlider,
  LoginAdContent,
  LoginIprojectSystemContent,
} from './loginv2.style'
import { LOGIN_AXONS_ONE } from 'config/env'

const LoginComponents = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    if (params.get('error') !== null) {
      handleLoginFailed({ data: null })
    }
  }, [location.search])
  const borderWarningname = false
  const borderWarningpass = false
  const [whichSystem, setWhichSystem] = useState('AD_LOGIN')
  const [remember, setRemember] = useState(true)
  const [isLoadingLoginAD, setIsLoadingLoginAD] = useState(false)
  const language = getCookie('lang')
  const word = lang[language]
  const [formAdlogin] = Form.useForm()

  const onFinish = async (data) => {
    setCookie('lang', 'en')
    try {
      dispatch(
        loginUser({
          username: data.username,
          password: data.password,
          remember: remember,
        }),
      )
    } catch (err) {
      console.error(err)
    }
  }

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo)
  }

  const checkRemember = (e) => {
    setRemember(e.target.checked)
  }

  const onFinishLoginAD = async (values) => {
    setIsLoadingLoginAD(true)
    await LoginLINK_Axons({
      email: values.email_ad,
    }).then((res) => {
      const { status } = res
      if (status !== 200) {
        setIsLoadingLoginAD(false)
      } else {
        setIsLoadingLoginAD(false)
      }
    })
  }

  const selectSystemLogin = () => {
    if (whichSystem === 'IPRO_LOGIN') {
      setWhichSystem('AD_LOGIN')
    } else {
      setWhichSystem('IPRO_LOGIN')
    }
  }

  return (
    <CardLogin>
      <CardContainer>
        <img
          className='nav-logo'
          src={Axonslogo}
          style={{ width: '128px', height: '128px', marginBottom: ' 16px' }}
        />
        <TitlePrimary>{'AXONS PROJECT'}</TitlePrimary>
        <AnimationSlider>
          <LoginAdContent
            className={
              whichSystem === 'AD_LOGIN' ? 'login-ad-active' : 'login-ad-inactive'
            }
          >
            <Form layout='vertical' form={formAdlogin} onFinish={onFinishLoginAD}>
              <Row style={{ minHeight: 87 }}>
                <Form.Item
                  name='email_ad'
                  style={{ width: '100%' }}
                  rules={[
                    {
                      required: true,
                      message: 'Please enter your corporate email',
                      whitespace: true,
                    },
                  ]}
                >
                  <Input
                    placeholder='Email'
                    size='large'
                    prefix={<IconEmail />}
                    type='email'
                  />
                </Form.Item>
              </Row>
            </Form>
            <Button
              loading={isLoadingLoginAD}
              className='BTN_Next'
              onClick={() => formAdlogin.submit()}
              type='primary'
            >
              Next
            </Button>
            <h4
              className='link-to-forgot'
              onClick={() => {
                // window.open('https://uss.cpf.co.th/', '_blank')
                history.push('login/forgotinternal')
              }}
            >
              Forgot your password ?
            </h4>
            <div className='or-style'>
              <div className='line' />
              <span>or</span>
              <div className='line' />
            </div>
          </LoginAdContent>
          <Button
            onClick={() => selectSystemLogin()}
            type='primary'
            className='BTN_ClassA'
            style={{ width: '100%', height: '40px' }}
          >
            {whichSystem === 'AD_LOGIN'
              ? 'Login with Local Account'
              : 'Login with Corporate Email'}
          </Button>
          <LoginIprojectSystemContent
            className={
              whichSystem === 'IPRO_LOGIN'
                ? 'login-iproject-active'
                : 'login-iproject-inactive'
            }
          >
            <div className='or-style'>
              <div className='line' /> <span>or</span> <div className='line' />
            </div>
            <Form
              // style={{ maxWidth: '343px' }}
              name='basic'
              initialValues={{
                remember: true,
              }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
            >
              <Form.Item
                label=''
                name='username'
                rules={[
                  {
                    required: true,
                    message: 'Please enter your email',
                  },
                ]}
              >
                <div
                  className={borderWarningname ? 'borderWar' : 'activeborderwar'}
                  style={{ marginBottom: '8px' }}
                >
                  <Input
                    className='input-title-position '
                    prefix={<UserOutlined className='site-form-item-icon' />}
                    placeholder='Email'
                  />
                </div>
              </Form.Item>
              <Form.Item
                label=''
                name='password'
                rules={[
                  {
                    required: true,
                    message: word['login_validate_password'],
                  },
                ]}
              >
                <div className={borderWarningpass ? 'borderWar' : 'activeborderwar'}>
                  <Input.Password
                    type='password'
                    prefix={<LockOutlined className='site-form-item-icon' />}
                    placeholder='Password'
                    iconRender={(visible) =>
                      visible ? (
                        <EyeOutlined style={{ fontSize: 20 }} />
                      ) : (
                        <EyeInvisibleOutlined style={{ fontSize: 20 }} />
                      )
                    }
                    style={{ marginBottom: '16px' }}
                  />
                </div>
              </Form.Item>
              <Form.Item name='remember' valuePropName='checked' noStyle>
                <Checkbox onChange={(e) => checkRemember(e)}>
                  {word['login_checkbox']}
                </Checkbox>
              </Form.Item>
              <Button
                htmlType='submit'
                className='BTN_Next'
                type='primary'
                style={{ width: '100%' }}
              >
                <h4>Login</h4>
              </Button>
              <h4
                className='link-to-forgot'
                onClick={() => {
                  history.push('login/forgot')
                }}
              >
                Forgot your password ?
              </h4>
            </Form>
          </LoginIprojectSystemContent>
        </AnimationSlider>
      </CardContainer>
    </CardLogin>
  )
}

export default LoginComponents
